/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $DocumentName = {
    properties: {
        name: {
    type: 'string',
    isRequired: true,
},
        msg: {
    type: 'string',
    isRequired: true,
},
    },
};